import { render, staticRenderFns } from "./TamamlananGorevList.vue?vue&type=template&id=0c236df2&scoped=true"
import script from "./TamamlananGorevList.vue?vue&type=script&lang=ts"
export * from "./TamamlananGorevList.vue?vue&type=script&lang=ts"
import style0 from "./TamamlananGorevList.vue?vue&type=style&index=0&id=0c236df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c236df2",
  null
  
)

export default component.exports